import { StoreApi } from 'zustand';
import createContext from 'zustand/context';
import { FeedStoreWithRedux } from '../types';

export const FeedStoreContext = createContext<StoreApi<FeedStoreWithRedux>>();
